import { CustomValidators } from './custom.validators';
export class HyperlinkHelper {
  public static formatMessage(element: string): string {
    const message = element.toString().trim().replace(/\n/gm, ' ').replace(/\r/gm, ' ').replace(/\t/gm, ' ');
    const linksFound = message.split(' ');
    let newMessage = '';
    if (linksFound) {
      for (let i = 0; i < linksFound.length; i++) {
        let target = '';
        if (
          linksFound[i].match(CustomValidators.urlPattern) ||
          linksFound[i].match(CustomValidators.simpleUrlPattern)
        ) {
          if (linksFound[i].match(CustomValidators.simpleUrlPattern)) {
            target = 'http://' + linksFound[i];
          } else {
            target = linksFound[i];
          }
          newMessage += '<a href="' + target + '" target="_blank">' + linksFound[i] + '</a>';
        } else {
          newMessage += linksFound[i];
        }
        if (i !== linksFound.length - 1) {
          newMessage += ' ';
        }
      }
    }
    return newMessage;
  }
}
